import React, { Suspense } from 'react';
import { ApolloProvider } from '@apollo/client/react';
import { createRoot } from 'react-dom/client';

import MainSiteLayout from '@buyside/components/presentation/MainSiteLayout/mainSiteLayout';

import lazyWithRetry from '@buyside/util/lazyWithRetry';

import generateClient from '@buyside/apollo/client';
import generatePublicClient from '@open/apollo/publicClient';

document.addEventListener('DOMContentLoaded', () => {
  const reactRootEl = document.getElementById('reactAppRoot');
  if (!reactRootEl) return;

  const rootPageName = reactRootEl.dataset.rootPageName;
  const hideNavigation = reactRootEl.dataset.hideNavigation === 'true';
  const rootPageEl = document.getElementById(`${rootPageName}`);
  if (!rootPageEl) return;

  const RootPage = lazyWithRetry(() =>
    import(
      /* webpackChunkName: "rootPages" */
      /* webpackMode: "eager" */
      `@buyside/components/rootPages/${rootPageName}`
    )
  );

  const currentUserFromRails = reactRootEl.dataset.currentUser
    ? JSON.parse(reactRootEl.dataset.currentUser)
    : null;

  const client = currentUserFromRails ? generateClient() : generatePublicClient();

  const root = createRoot(reactRootEl);
  root.render(
    <ApolloProvider client={client}>
      <MainSiteLayout
        currentUserFromRails={currentUserFromRails}
        hideNavigation={hideNavigation}
        RootComponent={
          <Suspense>
            <RootPage {...rootPageEl.dataset} />
          </Suspense>
        }
      />
    </ApolloProvider>
  );
});
